/* eslint-disable no-extra-boolean-cast */
import React, { useState, useEffect } from 'react';
import { SelectGroup } from 'module-tsl-ui-elements';
import { getFromContext } from '../../../AlertFiltersContext';
import { MAX_DISTANCE } from '../../../helpers/constants';

const unit = (locale) => (locale === 'gb' || locale === 'us' ? 'miles' : 'km');

const generateOptions = (country) =>
  MAX_DISTANCE.map((distance, index) => ({
    value: distance.name,
    label: `${distance.name} ${unit(country)}`,
    key: `distance-${index}`,
  }));

export const FilterInputDistance = () => {
  const { state, dispatch } = getFromContext();
  const {
    i18n: { country },
    facets,
    enableDistance,
  } = state;
  const [distance, setDistance] = useState('30'); // 30 miles or km default

  const [distanceFacet] = facets.filter(({ queryStringId }) => queryStringId.indexOf('maxdistance') !== -1);
  const [locationFacet] = state.facets.filter(
    ({ queryStringId }) => queryStringId.indexOf('location') !== -1 || queryStringId.indexOf('point') !== -1,
  );

  useEffect(() => {
    if (distanceFacet && locationFacet) {
      const [distanceValue] = MAX_DISTANCE.filter(({ id }) => id === distanceFacet.queryAs);

      setDistance(distanceValue.name);

      dispatch({
        type: 'enableDistance',
        enable: true,
      });
    } else {
      setDistance('30');
    }
  }, [facets]);

  const onChange = ({ target: { value } }) => {
    const [distanceValue] = MAX_DISTANCE.filter(({ name }) => name === value);
    setDistance(value);
    const facet = {
      name: `Radius: ${value} ${unit(country)}`,
      queryStringId: `maxdistance=${encodeURIComponent(distanceValue.id)}`,
      queryAs: distanceValue.id,
    };

    dispatch({
      type: Boolean(distanceFacet) ? 'update' : 'add',
      facet,
      key: 'maxdistance',
    });
  };

  return (
    <SelectGroup
      self={{ group: 'distance' }}
      label={{ text: 'Max Distance' }}
      select={{
        disabled: !enableDistance,
        value: distance,
        onChange,
        options: generateOptions(country),
        name: 'maxdistance',
      }}
    />
  );
};
